(function () {
  const FACETS = [
    { attribute: 'meta.custom.genre', label: 'Genre' },
    { attribute: 'meta.custom.style', label: 'Style' },
    { attribute: 'format_groups', label: 'Format' },
    { attribute: 'meta.custom.release_year', label: 'Year' },
  ];

  const PRICE_RANGES = [
    { label: 'Under $10', min: null, max: 10 },
    { label: '$10-$20', min: 10, max: 20 },
    { label: '$20-$30', min: 20, max: 30 },
    { label: '$30-$50', min: 30, max: 50 },
    { label: '$50+', min: 50, max: null },
  ];

  const AVAILABILITY_FILTERS = [
    { label: 'In stock', value: 'true' },
    { label: 'Sold out', value: 'false' },
  ];

  const FORMAT_FACET_ATTRIBUTE = 'format_groups';
  const RAW_FORMAT_FACET_ATTRIBUTE = 'meta.custom.format';
  const STICKY_FACET_ATTRIBUTES = new Set([FORMAT_FACET_ATTRIBUTE, 'meta.custom.release_year']);
  const FORMAT_GROUPS = [
    { label: 'LP', value: 'format_lp', test: function (value) { return hasFormatToken(value, 'LP'); } },
    { label: '12"', value: 'format_12_inch', test: function (value) { return value.indexOf('12"') !== -1; } },
    { label: '7"', value: 'format_7_inch', test: function (value) { return value.indexOf('7"') !== -1; } },
    { label: '10"', value: 'format_10_inch', test: function (value) { return value.indexOf('10"') !== -1 || value.indexOf('9"') !== -1 || value.indexOf('8"') !== -1; } },
    { label: 'CD', value: 'format_cd', test: function (value) { return hasFormatToken(value, 'CD'); } },
    { label: 'Cassette', value: 'format_cassette', test: function (value) { return /cassette/i.test(value); } },
    { label: 'Box Set', value: 'format_box_set', test: function (value) { return /box set/i.test(value); } },
    { label: 'DVD', value: 'format_dvd', test: function (value) { return hasFormatToken(value, 'DVD') || /dvd-video/i.test(value); } },
    { label: 'Books / Magazines', value: 'format_books_magazines', test: function (value) { return /\bbook\b|magazine/i.test(value); } },
  ];

  const FACET_COLLAPSED_LIMIT = 20;
  const FACET_EXPANDED_LIMIT = 100;
  const FACET_COLLAPSED_LIMITS = {
    'meta.custom.genre': 5,
    'meta.custom.style': 10,
    'format_groups': 5,
    'meta.custom.release_year': 5,
  };
  const FACETS_COLLAPSED_BY_DEFAULT = new Set();
  const AVAILABILITY_LOCKED_ROUTES = new Set(['back-in-stock', 'best-sellers']);
  const TAG_BACKED_COLLECTION_HANDLES = new Set(['styles', 'labels', 'artists']);
  const GENRE_FACET_ROUTES = new Set(['all', 'back-in-stock', 'best-sellers', 'on-sale', 'used']);
  const FORMAT_ROUTES = {
    'format-lp': 'format_lp',
    'format-12-inch': 'format_12_inch',
    'format-10-inch': 'format_10_inch',
    'format-7-inch': 'format_7_inch',
    'format-cd': 'format_cd',
    'format-cassette': 'format_cassette',
    'format-box-set': 'format_box_set',
    'format-dvd': 'format_dvd',
    'books-magazines': 'format_books_magazines',
  };
  const RAW_FORMAT_ROUTE_VALUES = {
    format_lp: ['LP', '2xLP', '3xLP', '4xLP', '5xLP', 'LP+LP', 'LP+CD', '2xLP+CD', 'LP+7"', '2xLP+7"', '3xLP+7"', 'Box Set+LP', 'Box Set+5xLP'],
    format_12_inch: ['12"', '2x12"', '3x12"', '4x12"', '5x12"', '12"+7"', 'LP+12"', '2xLP+12"', 'Box Set+12"'],
    format_10_inch: ['10"', '2x10"', '8"', '9"', '10"+7"', 'LP+10"', 'Box Set+10"'],
    format_7_inch: ['7"', '2x7"', '3x7"', '4x7"', '5x7"', '7"+7"', '10"+7"', '12"+7"', 'LP+7"', '2xLP+7"', '3xLP+7"', '5x7"+Box Set'],
    format_cd: ['CD', '2xCD', '3xCD', '4xCD', '5xCD', '6xCD', '7xCD', '8xCD', '9xCD', '10xCD', '17xCD+Box Set', '19xCD+Box Set', 'CD+DVD', 'LP+CD', '2xLP+CD', '2xCD+12"', 'Box Set+CD'],
    format_cassette: ['Cassette', '2xCassette', '3xCassette', '4xCassette', 'Cassette+Cassette', 'Box Set+Cassette'],
    format_box_set: ['Box Set', 'Box Set+LP', 'Box Set+5xLP', 'Box Set+CD', '17xCD+Box Set', '19xCD+Box Set', '5x7"+Box Set'],
    format_dvd: ['DVD', '2xDVD', 'DVD-Video', 'CD+DVD', 'LP+DVD'],
    format_books_magazines: ['Book', 'Magazine', 'Books', 'Magazines'],
  };

  const GENRE_ROUTES = {
    electronic: 'Electronic',
    'funk-soul': 'Funk / Soul',
    rock: 'Rock',
    jazz: 'Jazz',
    'folk-world-country': 'Folk, World, & Country',
    pop: 'Pop',
    latin: 'Latin',
    'hip-hop': 'Hip Hop',
    reggae: 'Reggae',
    'stage-screen': 'Stage & Screen',
    classical: 'Classical',
    blues: 'Blues',
    'non-music': 'Non-Music',
  };

  const TAG_ROUTE_FILTERS = {
    'house-techno-electro': [
      'House',
      'Acid House',
      'Deep House',
      'Electro House',
      'Euro House',
      'Garage House',
      'Ghetto House',
      'Hard House',
      'Italo House',
      'Tech House',
      'Tribal House',
      'Tropical House',
      'Hip-House',
      'Witch House',
      'Techno',
      'Deep Techno',
      'Dub Techno',
      'Hard Techno',
      'Minimal Techno',
      'Ghettotech',
      'Tech Trance',
      'Trance',
      'Neo Trance',
      'Electro',
      'Dark Electro',
      'Gqom',
      'Progressive House',
      'Progressive Trance',
    ],
    'funk-soul-disco': [
      'Funk / Soul',
      'Disco',
      'Italo-Disco',
      'Euro-Disco',
      'Boogie',
      'Hi NRG',
      'Balearic',
      'Nu-Disco',
      'Jazzdance',
      'Freestyle',
    ],
    'hip-hop-breakbeat': [
      'EBM',
      'Hip Hop',
      'Boogie',
      'Jungle',
      'Drum n Bass',
      'Breakbeat',
      'Broken Beat',
      'Bass Music',
      'Breaks',
      'Future Jazz',
      'Breakcore',
      'UK Garage',
      'UK Funky',
      'IDM',
      'Dubstep',
      'Trip Hop',
      'Footwork',
      'Trap',
      'Favela Funk',
    ],
    'jazz-international': [
      'Jazz-Funk',
      'Jazz-Rock',
      'Jazzdance',
      'Afro-Cuban Jazz',
      'Acid Jazz',
      'Soul-Jazz',
      'Avant-garde Jazz',
      'Free Jazz',
      'Hard Bop',
      'Zouk',
      'African',
      'Afrobeat',
      'Highlife',
      'MPB',
      'Calypso',
      'Samba',
      'Funaná',
      'Bossanova',
      'Soukous',
      'Cumbia',
      'Latin',
      'Reggae',
      'Raï',
      'Ranchera',
      'Son',
      'Merengue',
      'Gamelan',
      'Chanson',
      'Krautrock',
      'Kwaito',
      'Mugham',
      'Indian Classical',
      'Carnatic',
      'Persian Classical',
      'Maloya',
      'Chinese Classical',
      'Religious',
      'Latin Jazz',
      'Boogaloo',
      'Yemenite Jewish',
      'Gqom',
      'Cubano',
      'Nhạc Vàng',
      'City pop',
      'Hawaiian',
      'Aboriginal',
      'Kaseko',
      'Rebetiko',
      'Nordic',
      'Volksmusik',
      'Jazz',
      'Fusion',
      'Candombe',
      'Griot',
      'Luk Krung',
      'Andean Music',
      'Bengali Music',
      'Mo Lam',
    ],
    'ambient-experimental': [
      'Ambient',
      'Dark Ambient',
      'Experimental',
      'Downtempo',
      'Leftfield',
      'Drone',
      'IDM',
      'Bass Music',
      'Electroacoustic',
      'Musique Concrète',
      'Abstract',
      'Noise',
      'Field Recording',
      'No Wave',
      'Avantgarde',
      'New Age',
    ],
    'rock-pop-blues': [
      'Rock',
      'Pop',
      'Blues',
      'Folk',
      'Psychedelic Rock',
      'Folk Rock',
      'Indie Rock',
      'New Wave',
      'Punk',
      'Pop Rock',
      'Chanson',
      'Krautrock',
      'Synthwave',
      'No Wave',
      'Synth-pop',
      'City pop',
      'Dance-pop',
    ],
    'soundtrack-classical': [
      'Classical',
      'Stage & Screen',
      'Non-Music',
      'Indian Classical',
      'Persian Classical',
      'Chinese Classical',
      'Religious',
      'Score',
      'Theme',
      'Soundtrack',
      'Sound Effects',
    ],
    magazine: ['Magazine', 'Book'],
    'record-store-day': ['RSD'],
    used: ['used'],
  };

  const RETRIEVE = [
    'title',
    'vendor',
    'handle',
    'price',
    'compare_at_price',
    'product_image',
    'image',
    'sku',
    'tags',
    'inventory_available',
    'id',
    'objectID',
    'meta.artists.name',
    'meta.labels.name',
    'meta.custom.series',
    'series_names',
    'meta.custom.genre',
    'meta.custom.style',
    'format_groups',
    'meta.custom.format_group',
    'meta.custom.format',
    'meta.custom.release_year',
    'meta.custom.audio',
    'audio_tracks',
    'has_audio',
  ];

  function boot() {
    document.querySelectorAll('[data-algolia-discogs-root]').forEach(initRoot);
    document.querySelectorAll('[data-algolia-recent-sellers-root]').forEach(initRecentSellers);
  }

  function initRoot(root) {
    const configEl = root.querySelector('[data-algolia-discogs-config]');
    if (!configEl) return;

    const config = JSON.parse(configEl.textContent || '{}');
    const els = {
      count: root.querySelector('[data-algolia-count]'),
      error: root.querySelector('[data-algolia-error]'),
      empty: root.querySelector('[data-algolia-empty]'),
      facets: root.querySelector('[data-algolia-facets]'),
      hits: root.querySelector('[data-algolia-hits]'),
      pagination: root.querySelector('[data-algolia-pagination]'),
      clear: root.querySelector('[data-algolia-clear]'),
      sort: root.querySelector('[data-algolia-sort]'),
      drawer: root.querySelector('[data-algolia-filter-drawer]'),
      filterOpen: root.querySelector('[data-algolia-filter-open]'),
      filterClose: root.querySelectorAll('[data-algolia-filter-close]'),
      enhancements: root.querySelectorAll('[data-algolia-enhancement]'),
    };

    const state = {
      config: config,
      page: getInitialPage(),
      sort: config.collectionHandle === 'best-sellers' ? 'popular' : config.defaultSort || 'newest',
      refinements: new Map(),
      priceRanges: new Set(),
      availability: new Set(),
      condition: new Set(),
      expandedFacets: new Set(),
      openedFacets: new Set(),
      formatFacetValues: {},
      stickyFacetValues: {},
      lockedFilters: getInitialFilters(config),
      lockedNumericFilters: getInitialNumericFilters(config),
      availabilityLocked: AVAILABILITY_LOCKED_ROUTES.has(config.collectionHandle),
      unavailableSorts: new Set(),
      focusResultsAfterSearch: false,
    };

    if (!config.appId || !config.searchApiKey || !config.indexName) {
      showError(els, 'Add the Algolia app ID, search-only API key, and product index name in this section settings.');
      return;
    }

    if (!window.algoliasearch) {
      showError(els, 'Algolia client failed to load.');
      return;
    }

    const client = window.algoliasearch(config.appId, config.searchApiKey);
    initInsights(config);

    if (els.filterOpen && els.drawer) {
      els.filterOpen.addEventListener('click', function () {
        trackGa4('algolia_filter_drawer_opened', baseEventParams(config, state));
        setFilterDrawer(els, true);
      });
    }

    els.filterClose.forEach(function (button) {
      button.addEventListener('click', function () {
        setFilterDrawer(els, false);
      });
    });

    if (els.sort) {
      els.sort.value = state.sort;
      els.sort.addEventListener('change', function () {
        state.sort = els.sort.value;
        state.page = 0;
        updatePageUrl(state.page, true);
        trackGa4(
          'algolia_sort_changed',
          Object.assign(baseEventParams(config, state), {
            sort: state.sort,
          })
        );
        search(client, config, els, state);
      });
    }

    if (els.clear) {
      els.clear.addEventListener('click', function () {
        state.refinements.clear();
        state.priceRanges.clear();
        state.availability.clear();
        state.condition.clear();
        state.page = 0;
        updatePageUrl(state.page, true);
        trackGa4('algolia_filters_cleared', baseEventParams(config, state));
        search(client, config, els, state);
      });
    }

    els.facets.addEventListener('change', function (event) {
      const input = event.target.closest('input[type="checkbox"][data-facet-attribute]');
      if (!input) return;

      toggleRefinement(state, input.dataset.facetAttribute, input.value, input.checked);
      state.page = 0;
      updatePageUrl(state.page, true);
      trackFilterEvent(config, state, input.dataset.facetAttribute, input.value, input.checked);
      search(client, config, els, state);
    });

    els.facets.addEventListener('click', function (event) {
      const button = event.target.closest('[data-facet-toggle]');
      if (!button) return;

      const attribute = button.dataset.facetToggle;
      if (state.expandedFacets.has(attribute)) {
        state.expandedFacets.delete(attribute);
      } else {
        state.expandedFacets.add(attribute);
      }
      renderFacets(els, state.lastResults, state);
    });

    els.facets.addEventListener('click', function (event) {
      const button = event.target.closest('[data-facet-open]');
      if (!button) return;

      const attribute = button.dataset.facetOpen;
      if (state.openedFacets.has(attribute)) {
        state.openedFacets.delete(attribute);
      } else {
        state.openedFacets.add(attribute);
      }
      renderFacets(els, state.lastResults, state);
    });

    els.facets.addEventListener('change', function (event) {
      const input = event.target.closest('input[type="checkbox"][data-price-range]');
      if (!input) return;

      if (input.checked) {
        state.priceRanges.add(input.value);
      } else {
        state.priceRanges.delete(input.value);
      }
      state.page = 0;
      updatePageUrl(state.page, true);
      trackGa4(
        'algolia_price_filter_changed',
        Object.assign(baseEventParams(config, state), {
          filter_value: PRICE_RANGES[Number(input.value)] ? PRICE_RANGES[Number(input.value)].label : input.value,
          checked: input.checked,
        })
      );
      search(client, config, els, state);
    });

    els.facets.addEventListener('change', function (event) {
      const input = event.target.closest('input[type="checkbox"][data-availability]');
      if (!input) return;

      if (input.checked) {
        state.availability.add(input.value);
      } else {
        state.availability.delete(input.value);
      }
      state.page = 0;
      updatePageUrl(state.page, true);
      trackGa4(
        'algolia_availability_filter_changed',
        Object.assign(baseEventParams(config, state), {
          filter_value: input.value,
          checked: input.checked,
        })
      );
      search(client, config, els, state);
    });

    els.facets.addEventListener('change', function (event) {
      const input = event.target.closest('input[type="checkbox"][data-condition]');
      if (!input) return;

      if (input.checked) {
        state.condition.add(input.value);
      } else {
        state.condition.delete(input.value);
      }
      state.page = 0;
      updatePageUrl(state.page, true);
      trackFilterEvent(config, state, 'tags', input.value === 'new' ? '-used' : 'used', input.checked);
      search(client, config, els, state);
    });

    els.hits.addEventListener('click', function (event) {
      const productLink = event.target.closest('[data-algolia-product-link]');
      const miniPlay = event.target.closest('.mini-player-play');

      if (productLink) {
        trackProductClick(productLink, config, state);
        return;
      }

      if (miniPlay) {
        const player = miniPlay.closest('.mini-audio-player');
        if (player) trackMiniPlayerPlay(player, config, state);
      }
    });
    bindQuickAddForms(els.hits);

    els.pagination.addEventListener('click', function (event) {
      const link = event.target.closest('a[data-page]');
      if (!link || els.hits.dataset.serverRendered === 'true' || !shouldHandlePaginationClick(event, link)) return;

      const nextPage = Number(link.dataset.page);
      if (!Number.isFinite(nextPage) || nextPage < 0) return;

      event.preventDefault();
      if (nextPage === state.page) return;

      state.page = nextPage;
      state.focusResultsAfterSearch = true;
      updatePageUrl(state.page, false);
      trackGa4(
        'algolia_page_changed',
        Object.assign(baseEventParams(config, state), {
          page: state.page + 1,
        })
      );
      search(client, config, els, state);
    });

    window.addEventListener('popstate', function () {
      const nextPage = getInitialPage();
      if (nextPage === state.page) return;

      state.page = nextPage;
      search(client, config, els, state);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    search(client, config, els, state);
  }

  function initRecentSellers(root) {
    const configEl = root.querySelector('[data-algolia-recent-sellers-config]');
    if (!configEl) return;

    const config = JSON.parse(configEl.textContent || '{}');
    const els = {
      error: root.querySelector('[data-algolia-recent-sellers-error]'),
      empty: root.querySelector('[data-algolia-recent-sellers-empty]'),
      hits: root.querySelector('[data-algolia-recent-sellers-hits]'),
    };
    const state = {
      config: config,
      page: 0,
      sort: 'popular',
      refinements: new Map(),
      priceRanges: new Set(),
      availability: new Set(),
      expandedFacets: new Set(),
      openedFacets: new Set(),
      formatFacetValues: {},
      stickyFacetValues: {},
      lockedFilters: [],
      lockedNumericFilters: ['sales_60d > 0'],
      availabilityLocked: false,
      unavailableSorts: new Set(),
    };

    if (!config.appId || !config.searchApiKey || !config.indexName || !els.hits) {
      showRecentSellersError(els, 'Add the Algolia app ID, search-only API key, and product index name.');
      return;
    }

    if (!window.algoliasearch) {
      showRecentSellersError(els, 'Algolia client failed to load.');
      return;
    }

    const client = window.algoliasearch(config.appId, config.searchApiKey);
    const indexName = config.indexName + '_sales_60d_desc';
    const index = client.initIndex(indexName);
    initInsights(config);

    els.hits.addEventListener('click', function (event) {
      const productLink = event.target.closest('[data-algolia-product-link]');
      const miniPlay = event.target.closest('.mini-player-play');

      if (productLink) {
        trackProductClick(productLink, config, state);
        return;
      }

      if (miniPlay) {
        const player = miniPlay.closest('.mini-audio-player');
        if (player) trackMiniPlayerPlay(player, config, state);
      }
    });
    bindQuickAddForms(els.hits);

    els.hits.classList.add('loading');
    index
      .search('', {
        hitsPerPage: Number(config.hitsPerPage || 10),
        page: 0,
        attributesToRetrieve: RETRIEVE,
        clickAnalytics: true,
        numericFilters: ['sales_60d > 0'],
        facetFilters: ['inventory_available:true'],
      })
      .then(function (results) {
        results.indexName = results.index || indexName;
        els.hits.classList.remove('loading');
        if (els.empty) els.empty.hidden = results.hits.length > 0;
        els.hits.innerHTML = results.hits
          .map(function (hit, index) {
            return '<li class="grid__item">' + renderCard(hit, config, results, index + 1) + '</li>';
          })
          .join('');
        syncWishlistButtons(els.hits);
        syncNotificationSignup(els.hits);
        syncMiniPlayers(els.hits);
      })
      .catch(function (error) {
        els.hits.classList.remove('loading');
        showRecentSellersError(els, error && error.message ? error.message : 'Algolia recent sellers unavailable.');
      });
  }

  function showRecentSellersError(els, message) {
    if (!els.error) return;
    els.error.textContent = message;
    els.error.hidden = false;
  }

  function setFilterDrawer(els, open) {
    if (!els.drawer) return;

    els.drawer.classList.toggle('is-open', open);
    els.drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    els.filterClose.forEach(function (element) {
      if (element.classList.contains('algolia-discogs__overlay')) {
        element.hidden = !open;
      }
    });
    document.documentElement.classList.toggle('algolia-discogs-drawer-open', open);
  }

  function getInitialFilters(config) {
    const tag = config.currentTag || inferTagFromPath(config);

    if (TAG_BACKED_COLLECTION_HANDLES.has(config.collectionHandle) && tag) {
      config.currentTag = tag;
      return [['tags:' + tag]];
    }

    const routeFacets = {
      series: 'series_names',
    };
    const facet = routeFacets[config.collectionHandle];

    if (facet && tag) {
      config.currentTag = tag;
      return [[facet + ':' + tag]];
    }

    if (GENRE_ROUTES[config.collectionHandle]) {
      return [['meta.custom.genre:' + GENRE_ROUTES[config.collectionHandle]]];
    }

    if (FORMAT_ROUTES[config.collectionHandle]) {
      const group = formatGroupByValue(FORMAT_ROUTES[config.collectionHandle]);
      if (group) {
        return [[FORMAT_FACET_ATTRIBUTE + ':' + group.value]];
      }
      return [[FORMAT_FACET_ATTRIBUTE + ':' + FORMAT_ROUTES[config.collectionHandle]]];
    }

    if (TAG_ROUTE_FILTERS[config.collectionHandle]) {
      return [
        TAG_ROUTE_FILTERS[config.collectionHandle].map(function (tagValue) {
          return 'tags:' + tagValue;
        }),
      ];
    }

    if (config.collectionHandle === 'back-in-stock') {
      return [['in_back_in_stock:true']];
    }

    if (config.collectionHandle === 'on-sale') {
      return [['tags:sale']];
    }

    return [];
  }

  function getInitialNumericFilters(config) {
    if (config.collectionHandle === 'best-sellers') {
      return ['sales_60d > 0'];
    }

    return [];
  }

  function inferTagFromPath(config) {
    const path = config.requestPath || '';
    const prefix = '/collections/' + config.collectionHandle + '/';
    if (!path.startsWith(prefix)) return '';

    const slug = decodeURIComponent(path.slice(prefix.length).split('/')[0] || '');
    if (!slug) return '';

    return slug
      .split('-')
      .filter(Boolean)
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  function toggleRefinement(state, attribute, value, checked) {
    const values = new Set(state.refinements.get(attribute) || []);
    if (checked) {
      values.add(value);
    } else {
      values.delete(value);
    }

    if (values.size) {
      state.refinements.set(attribute, values);
    } else {
      state.refinements.delete(attribute);
    }
  }

  function buildFacetFilters(state) {
    const filters = state.lockedFilters.map(function (group) {
      return group.slice();
    });

    state.refinements.forEach(function (values, attribute) {
      if (attribute === FORMAT_FACET_ATTRIBUTE) {
        const formatFilters = expandFormatRefinements(values, state.formatFacetValues);
        if (formatFilters.length) filters.push(formatFilters);
        return;
      }

      filters.push(
        Array.from(values).map(function (value) {
          return attribute + ':' + value;
        })
      );
    });

    if (state.availability.size === 1) {
      filters.push(
        Array.from(state.availability).map(function (value) {
          return 'inventory_available:' + value;
        })
      );
    }

    if (state.condition.size === 1) {
      const condition = Array.from(state.condition)[0];
      filters.push('tags:' + (condition === 'new' ? '-used' : 'used'));
    }

    return filters;
  }

  function expandFormatRefinements(values, knownFormatValues) {
    const filters = [];
    values.forEach(function (value) {
      const group = FORMAT_GROUPS.find(function (item) {
        return item.value === value || item.label === value;
      });

      filters.push(FORMAT_FACET_ATTRIBUTE + ':' + (group ? group.value : value));
    });
    return Array.from(new Set(filters));
  }

  function formatGroupByValue(value) {
    return FORMAT_GROUPS.find(function (item) {
      return item.value === value;
    });
  }

  function getIndexName(config, state) {
    const base = config.indexName;
    const replicas = {
      newest: base + '_newest_added_desc',
      popular: base + '_sales_60d_desc',
    };

    if (config.collectionHandle === 'back-in-stock' && state.sort === 'newest') {
      return base + '_back_in_stock_recent';
    }

    if (config.collectionHandle === 'best-sellers') {
      return replicas.popular;
    }

    if (state.unavailableSorts.has(state.sort)) return base;
    return replicas[state.sort] || base;
  }

  function search(client, config, els, state) {
    setLoading(els, true);
    hideError(els);

    const indexName = getIndexName(config, state);
    const index = client.initIndex(indexName);
    const visibleFacets = getVisibleFacets(config);

    index
      .search('', {
        attributesToRetrieve: RETRIEVE,
        facets: visibleFacets.map(function (facet) {
          return facet.attribute;
        }).concat([RAW_FORMAT_FACET_ATTRIBUTE]),
        facetFilters: buildFacetFilters(state),
        numericFilters: buildNumericFilters(state),
        hitsPerPage: Number(config.hitsPerPage) || 20,
        clickAnalytics: true,
        maxValuesPerFacet: FACET_EXPANDED_LIMIT,
        page: state.page,
      })
      .then(function (results) {
        results.indexName = indexName;
        const nextHits = buildHitsFragment(results, config);
        const nextPagination = buildPaginationFragment(results);

        assertUsableInitialResults(els.hits, results);
        state.lastResults = results;
        renderFacets(els, results, state);
        renderCount(els, results, config);
        commitHits(els, results, nextHits);
        commitPagination(els, nextPagination);
        setEnhancementsReady(els);
        setLoading(els, false);

        if (state.focusResultsAfterSearch) {
          state.focusResultsAfterSearch = false;
          els.hits.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (els.count) els.count.focus({ preventScroll: true });
        }
      })
      .catch(function (error) {
        if (isMissingIndexError(error) && state.sort !== 'newest') {
          state.unavailableSorts.add(state.sort);
          showError(els, 'This sort needs an Algolia replica before it can be used. Showing Newest added for now.');
          state.sort = 'newest';
          if (els.sort) els.sort.value = state.sort;
          search(client, config, els, state);
          return;
        }

        const showingFallback = els.hits.dataset.serverRendered === 'true';
        const message = error && error.code === 'STOREFRONT_EMPTY_RESULTS'
          ? 'Live filters are temporarily unavailable because store and search results are still syncing. Showing the store collection.'
          : showingFallback
            ? 'Live filters are temporarily unavailable. Showing the store collection.'
            : 'Live filters are temporarily unavailable. Showing the last successful results.';
        showError(els, message);
        state.focusResultsAfterSearch = false;
        setLoading(els, false);
      });
  }

  function assertUsableInitialResults(hitsElement, results) {
    if (!hitsElement || hitsElement.dataset.serverRendered !== 'true') return;

    const serverItems = Array.from(hitsElement.querySelectorAll('[data-server-product-handle]'));
    if (serverItems.length && !results.hits.length) {
      const emptyError = new Error('Algolia returned no products for a nonempty Shopify collection page.');
      emptyError.code = 'STOREFRONT_EMPTY_RESULTS';
      throw emptyError;
    }
  }

  function setEnhancementsReady(els) {
    els.enhancements.forEach(function (element) {
      element.hidden = false;
    });
  }

  function buildNumericFilters(state) {
    const filters = state.lockedNumericFilters.slice();
    if (!state.priceRanges.size) return filters;

    filters.push(
      Array.from(state.priceRanges)
        .map(function (value) {
          const range = PRICE_RANGES[Number(value)];
          if (!range) return null;
          if (range.min === null) return 'price < ' + range.max;
          if (range.max === null) return 'price >= ' + range.min;
          return 'price:' + range.min + ' TO ' + range.max;
        })
        .filter(Boolean)
    );

    return filters;
  }

  function isMissingIndexError(error) {
    const message = error && error.message ? error.message : '';
    return /index .* does not exist|Index .* does not exist|does not exist/i.test(message);
  }

  function setLoading(els, loading) {
    if (!els.hits) return;
    els.hits.classList.toggle('loading', loading);
    els.hits.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function renderCount(els, results, config) {
    const label = config.currentTag || config.collectionTitle || 'collection';
    els.count.textContent = results.nbHits + ' products for ' + label;
  }

  function buildHitsFragment(results, config) {
    const template = document.createElement('template');
    template.innerHTML = results.hits
      .map(function (hit, index) {
        const position = results.page * results.hitsPerPage + index + 1;
        return '<li class="grid__item">' + renderCard(hit, config, results, position) + '</li>';
      })
      .join('');
    return template.content;
  }

  function commitHits(els, results, fragment) {
    els.empty.hidden = results.hits.length > 0;
    els.hits.replaceChildren(fragment);
    els.hits.dataset.serverRendered = 'false';
    trackRenderedSearchAttribution(els.hits);
    syncWishlistButtons(els.hits);
    syncNotificationSignup(els.hits);
    syncMiniPlayers(els.hits);
  }

  function renderCard(hit, config, results, position) {
    const rawProductId = String(hit.id || '');
    const rawVariantId = String(hit.objectID || '');
    const productId = escapeHtml(rawProductId || rawVariantId);
    const objectId = escapeAttribute(rawVariantId);
    const indexName = escapeAttribute(results.indexName || config.indexName || '');
    const queryId = escapeAttribute(results.queryID || '');
    const title = escapeHtml(hit.title || 'Untitled product');
    const vendor = escapeHtml(hit.vendor || '');
    const url = hit.handle ? '/products/' + encodeURIComponent(hit.handle) : '#';
    const image = getImageUrl(hit);
    const available = hit.inventory_available !== false;
    const compareAt = parseMoneyValue(hit.compare_at_price);
    const price = parseMoneyValue(hit.price);
    const freeWithOrder = hitHasTag(hit, 'free-with-order');
    const onSale = available && !freeWithOrder && compareAt !== null && price !== null && compareAt > price;
    const audioTracks = getAudioTracks(hit);

    return [
      '<div class="card-wrapper product-card-wrapper underline-links-hover">',
      '<div class="card card--standard ' + (image ? 'card--media' : 'card--text') + '" style="--ratio-percent: 100%;">',
      '<div class="card__inner color-background-1 gradient ratio" style="--ratio-percent: 100%;">',
      image ? renderImage(image, title, position, config, results) : '',
      '<div class="card__content">',
      '<div class="card__information">',
      '<h3 class="card__heading" id="title-algolia-' + productId + '" aria-hidden="true">',
      '<a href="' + escapeAttribute(url) + '" id="CardImageLink-algolia-' + productId + '" class="full-unstyled-link" aria-hidden="true" tabindex="-1" data-algolia-product-link data-object-id="' + objectId + '" data-index-name="' + indexName + '" data-query-id="' + queryId + '" data-position="' + position + '" data-product-id="' + productId + '" data-product-title="' + escapeAttribute(hit.title || '') + '">' + title + '</a>',
      '</h3>',
      '</div>',
      renderBadge(productId, available, onSale, 'top'),
      '</div>',
      '</div>',
      '<div class="card__content">',
      '<div class="card__information">',
      '<h3 class="card__heading h5" id="title-algolia-bottom-' + productId + '">',
      '<a href="' + escapeAttribute(url) + '" id="CardLink-algolia-' + productId + '" class="full-unstyled-link" data-algolia-product-link data-object-id="' + objectId + '" data-index-name="' + indexName + '" data-query-id="' + queryId + '" data-position="' + position + '" data-product-id="' + productId + '" data-product-title="' + escapeAttribute(hit.title || '') + '">' + title + '</a>',
      '</h3>',
      '<div class="card-information">',
      config.showVendor && vendor ? '<span class="visually-hidden">Vendor</span><div class="caption-with-letter-spacing light">' + vendor + '</div>' : '',
      renderPrice(price, compareAt, config, freeWithOrder),
      '</div>',
      '<div class="algolia-discogs__card-actions">',
      audioTracks.length ? renderMiniPlayer(productId, audioTracks) : '',
      renderAddToCart(productId, objectId, indexName, queryId, available, hit.title || '', rawProductId, config, freeWithOrder),
      '</div>',
      '</div>',
      renderBadge(productId, available, onSale, 'bottom'),
      '</div>',
      '</div>',
      renderWishlistButton(hit, rawProductId, rawVariantId, available, price, compareAt, image, url),
      '</div>',
    ].join('');
  }

  function renderWishlistButton(hit, productId, variantId, available, price, compareAt, image, url) {
    if (!productId && !variantId && !hit.sku) return '';

    return [
      '<button type="button" class="further-wishlist-button further-wishlist-button--icon further-wishlist-button--card"',
      ' data-further-wishlist-toggle',
      ' data-wishlist-product-id="' + escapeAttribute(productId) + '"',
      ' data-wishlist-variant-id="' + escapeAttribute(variantId) + '"',
      ' data-wishlist-sku="' + escapeAttribute(hit.sku || '') + '"',
      ' data-wishlist-title="' + escapeAttribute(hit.title || '') + '"',
      ' data-wishlist-vendor="' + escapeAttribute(hit.vendor || '') + '"',
      ' data-wishlist-handle="' + escapeAttribute(hit.handle || '') + '"',
      ' data-wishlist-url="' + escapeAttribute(url) + '"',
      ' data-wishlist-image="' + escapeAttribute(image || '') + '"',
      ' data-wishlist-price="' + escapeAttribute(price === null ? '' : String(price)) + '"',
      ' data-wishlist-compare-at-price="' + escapeAttribute(compareAt === null ? '' : String(compareAt)) + '"',
      ' data-wishlist-available="' + (available ? 'true' : 'false') + '"',
      ' data-wishlist-source="native"',
      ' data-wishlist-add-label="Save"',
      ' data-wishlist-remove-label="Saved"',
      ' aria-pressed="false"',
      '>',
      '<span class="further-wishlist-button__icon" aria-hidden="true">&#9825;</span>',
      '<span class="visually-hidden">Save</span>',
      '</button>',
    ].join('');
  }

  function renderMiniPlayer(productId, tracks) {
    const tracksJson = escapeAttribute(JSON.stringify(tracks));

    return [
      '<div id="mini-audio-player-' + productId + '" class="mini-audio-player" data-audio-tracks="' + tracksJson + '" data-product-id="' + productId + '">',
      '<audio id="audio-player-' + productId + '" preload="none"></audio>',
      '<div class="mini-player-controls">',
      '<button type="button" class="mini-player-previous" aria-label="Previous Track" onclick="miniPlayer.previousTrack(event, \'' + productId + '\')"><svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M6 6h2v12H6zm3.5 6l8.5 6V6z"/></svg></button>',
      '<button type="button" class="mini-player-play" aria-label="Play/Pause" onclick="miniPlayer.togglePlayPause(event, \'' + productId + '\')" data-play-icon="&lt;svg aria-hidden=&quot;true&quot; focusable=&quot;false&quot; width=&quot;16&quot; height=&quot;16&quot; viewBox=&quot;0 0 24 24&quot; fill=&quot;currentColor&quot;&gt;&lt;path d=&quot;M8 5v14l11-7z&quot;/&gt;&lt;/svg&gt;" data-pause-icon="&lt;svg aria-hidden=&quot;true&quot; focusable=&quot;false&quot; width=&quot;16&quot; height=&quot;16&quot; viewBox=&quot;0 0 24 24&quot; fill=&quot;currentColor&quot;&gt;&lt;path d=&quot;M6 4h4v16H6V4zm8 0h4v16h-4V4z&quot;/&gt;&lt;/svg&gt;"><svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></button>',
      '<button type="button" class="mini-player-next" aria-label="Next Track" onclick="miniPlayer.nextTrack(event, \'' + productId + '\')"><svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"/></svg></button>',
      '</div>',
      '<div class="mini-player-progress-container"><progress id="progress-bar-' + productId + '" class="mini-progress" value="0" max="1"></progress></div>',
      '</div>',
    ].join('');
  }

  function renderAddToCart(productId, variantId, indexName, queryId, available, productTitle, rawProductId, config, freeWithOrder) {
    if (!variantId) return '';
    if (!available) return renderNotifySignup(productId, productTitle, rawProductId, config);

    const buttonLabel = freeWithOrder ? 'Add free with any other item' : 'Add to cart';
    const freeAttrs = freeWithOrder ? ' data-free-with-order="true"' : '';

    return [
      '<form method="post" action="/cart/add" class="algolia-discogs__quick-add" enctype="multipart/form-data" data-algolia-quick-add data-object-id="' + escapeAttribute(variantId) + '" data-index-name="' + escapeAttribute(indexName) + '" data-query-id="' + escapeAttribute(queryId) + '" data-product-id="' + escapeAttribute(rawProductId || productId) + '"' + freeAttrs + '>',
      '<input type="hidden" name="id" value="' + escapeAttribute(variantId) + '">',
      '<input type="hidden" name="quantity" value="1">',
      '<button type="submit" name="add" class="quick-add__submit button button--full-width button--secondary algolia-discogs__add-button" data-product-id="' + productId + '">',
      '<span>' + buttonLabel + '</span>',
      '</button>',
      '<p class="algolia-discogs__free-error" data-algolia-cart-message role="status" aria-live="polite" aria-atomic="true" style="min-height:1.4em"></p>',
      '</form>',
    ].join('');
  }

  function hitHasTag(hit, tagName) {
    const wanted = String(tagName || '').trim().toLowerCase();
    const tags = hit && hit.tags;
    if (!wanted || !Array.isArray(tags)) return false;
    return tags.some(function (tag) {
      return String(tag).trim().toLowerCase() === wanted;
    });
  }

  // Serialize additions so rapid clicks on different cards also keep cart UI in order.
  let quickAddQueue = Promise.resolve();

  function bindQuickAddForms(root) {
    if (!root || root.dataset.algoliaQuickAddBound === 'true' || !window.fetch || !window.FormData) return;
    root.dataset.algoliaQuickAddBound = 'true';
    root.addEventListener('submit', function (event) {
      const form = event.target;
      if (!form || form.tagName !== 'FORM' || !form.hasAttribute('data-algolia-quick-add')) return;
      event.preventDefault();
      if (form.dataset.cartPending === 'true') return;
      form.dataset.cartPending = 'true';
      const button = form.querySelector('[type="submit"]');
      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('aria-busy', 'true');
      }
      setQuickAddMessage(form, 'Adding…');
      quickAddQueue = quickAddQueue.then(function () {
        return submitQuickAdd(form);
      }).catch(function () {
        setQuickAddMessage(form, 'Could not confirm the add. Check your cart before trying again.');
      }).finally(function () {
        delete form.dataset.cartPending;
        if (button) {
          button.removeAttribute('aria-disabled');
          button.removeAttribute('aria-busy');
        }
      });
    });
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function setQuickAddMessage(form, message) {
    const element = form.querySelector('[data-algolia-cart-message]');
    if (!element) return;
    element.hidden = false;
    element.textContent = message;
  }

  async function submitQuickAdd(form) {
    let addAttempted = false;
    try {
      if (form.dataset.freeWithOrder === 'true') {
        const response = await fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Could not check your cart. Try again.');
        const cart = await response.json();
        const variantId = String(form.querySelector('input[name="id"]').value);
        const items = cart.items || [];
        const hasCompanion = items.some(function (item) {
          return String(item.variant_id) !== variantId;
        });
        const alreadyInCart = items.some(function (item) {
          return String(item.variant_id) === variantId;
        });
        if (!hasCompanion) {
          setQuickAddMessage(form, 'Add another item to your cart first. This record is free with any other purchase.');
          return;
        }
        if (alreadyInCart) {
          setQuickAddMessage(form, 'Limit 1 free copy per order.');
          return;
        }
      }
      const body = new FormData(form);
      body.append('sections', 'cart-icon-bubble');
      body.append('sections_url', window.location.pathname);
      trackSearchAttributionFromElement(form);
      addAttempted = true;
      const response = await fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body,
      });
      const added = await response.json();
      if (!response.ok || added.status) {
        setQuickAddMessage(form, (added.description || added.message || 'Could not add this record.') + ' Check your cart before trying again.');
        await refreshQuickAddCart();
        return;
      }
      // A UI refresh failure must never turn a confirmed add into a retry prompt.
      setQuickAddMessage(form, 'Added to cart.');
      await refreshQuickAddCart(added.sections);
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'algolia-quick-add', productVariantId: body.get('id'), cartData: added });
        }
      } catch (error) {
        console.error(error);
      }
    } catch (error) {
      setQuickAddMessage(form, addAttempted
        ? 'Could not confirm the add. Check your cart before trying again.'
        : 'Could not check your cart. Try again.');
      if (addAttempted) await refreshQuickAddCart();
    }
  }

  async function refreshQuickAddCart(sections) {
    try {
      if (!sections || !sections['cart-icon-bubble']) {
        const response = await fetch(cartRoot() + '?sections=cart-icon-bubble', { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        sections = await response.json();
      }
      const icon = document.getElementById('cart-icon-bubble');
      const html = sections && sections['cart-icon-bubble'];
      if (!icon || !html) return;
      const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (section) icon.innerHTML = section.innerHTML;
    } catch (error) {
      console.error(error);
    }
  }

  function renderNotifySignup(productId, productTitle, rawProductId, config) {
    const gid = productGid(rawProductId);
    if (!gid) return '';
    const email = config.customerEmail || '';
    const endpoint = config.notificationEndpoint || 'https://record-notifications.orders-e73.workers.dev';
    const inputId = 'NotifyEmail-algolia-' + cleanId(productId);

    return [
      '<form class="notification-signup-form notification-signup--card algolia-discogs__quick-add algolia-discogs__notify-form"',
      ' data-endpoint="' + escapeAttribute(endpoint) + '"',
      ' data-target-type="product"',
      ' data-target-label="' + escapeAttribute(productTitle || '') + '"',
      ' data-product-gid="' + escapeAttribute(gid) + '"',
      '>',
      email
        ? '<input type="hidden" name="email" value="' + escapeAttribute(email) + '"><button type="submit" class="quick-add__submit button button--full-width button--secondary algolia-discogs__add-button"><span>Notify me</span></button>'
        : [
          '<button type="button" class="quick-add__submit button button--full-width button--secondary notification-signup-toggle algolia-discogs__add-button" aria-expanded="false"><span>Notify me</span></button>',
          '<div class="notification-signup-panel" hidden>',
          '<p class="notification-signup-copy">We\'ll email you when this is back in stock.</p>',
          '<div class="field">',
          '<input id="' + inputId + '" class="field__input" type="email" name="email" placeholder="Email address" autocomplete="email" required>',
          '<label class="field__label" for="' + inputId + '">Email address</label>',
          '</div>',
          '<button type="submit" class="button button--full-width button--secondary">Notify me</button>',
          '</div>',
        ].join(''),
      '<p class="notification-signup-message" aria-live="polite"></p>',
      '</form>',
    ].join('');
  }

  function renderImage(image, title, position, config, results) {
    const responsive = getResponsiveImage(image);
    const hitsPerPage = Number(results.hitsPerPage) || Number(config.hitsPerPage) || 40;
    const positionOnPage = position - results.page * hitsPerPage;
    const loading = positionOnPage === 1
      ? ' loading="eager" fetchpriority="high"'
      : ' loading="lazy"';
    const srcset = responsive.srcset
      ? ' srcset="' + escapeAttribute(responsive.srcset) + '" sizes="' + escapeAttribute(getImageSizes(config)) + '"'
      : '';

    return [
      '<div class="card__media">',
      '<div class="media media--transparent media--hover-effect">',
      '<img src="' + escapeAttribute(responsive.src) + '"' + srcset + ' width="533" height="533" alt="' + title + '" class="motion-reduce" decoding="async"' + loading + '>',
      '</div>',
      '</div>',
    ].join('');
  }

  function getResponsiveImage(image) {
    let parsed;
    try {
      parsed = new URL(image, window.location.origin);
    } catch (error) {
      return { src: image, srcset: '' };
    }

    const host = parsed.hostname.toLowerCase();
    const isShopifyCdn = host === 'cdn.shopify.com'
      || parsed.pathname.indexOf('/cdn/shop/') !== -1
      || parsed.pathname.indexOf('/s/files/') !== -1;
    if (!isShopifyCdn) return { src: image, srcset: '' };

    const widths = [165, 360, 533, 720];
    return {
      src: imageWithWidth(parsed, 533),
      srcset: widths.map(function (width) {
        return imageWithWidth(parsed, width) + ' ' + width + 'w';
      }).join(', '),
    };
  }

  function imageWithWidth(parsedUrl, width) {
    const candidate = new URL(parsedUrl.toString());
    candidate.searchParams.set('width', String(width));
    return candidate.toString();
  }

  function getImageSizes(config) {
    const desktopColumns = Math.max(1, Number(config.columnsDesktop) || 5);
    const mobileColumns = Math.max(1, Number(config.columnsMobile) || 2);
    return '(min-width: 990px) calc((100vw - 32rem) / ' + desktopColumns + '), '
      + '(min-width: 750px) calc((100vw - 8rem) / 3), '
      + 'calc((100vw - 3.5rem) / ' + mobileColumns + ')';
  }

  function renderBadge(productId, available, onSale, placement) {
    const badgeId = 'Badge-algolia-' + productId + '-' + placement;
    const hidden = placement === 'top' ? ' aria-hidden="true"' : '';
    if (!available) {
      return '<div class="card__badge bottom left"' + hidden + '><span id="' + badgeId + '" class="badge badge--bottom-left color-inverse">Sold out</span></div>';
    }
    if (onSale) {
      return '<div class="card__badge bottom left"' + hidden + '><span id="' + badgeId + '" class="badge badge--bottom-left color-accent-2">Sale</span></div>';
    }
    return '<div class="card__badge bottom left"' + hidden + '></div>';
  }

  function renderPrice(price, compareAt, config, freeWithOrder) {
    if (price === null) return '';

    if (freeWithOrder && price === 0) {
      return [
        '<div class="price">',
        '<div class="price__container">',
        '<div class="price__regular"><span class="visually-hidden">Regular price</span><span class="price-item price-item--regular">FREE</span></div>',
        '</div>',
        '</div>',
      ].join('');
    }

    const sale = compareAt !== null && compareAt > price;
    return [
      '<div class="price' + (sale ? ' price--on-sale' : '') + '">',
      '<div class="price__container">',
      '<div class="price__regular"><span class="visually-hidden">Regular price</span><span class="price-item price-item--regular">' + formatMoney(price, config) + '</span></div>',
      sale
        ? '<div class="price__sale"><span class="visually-hidden">Sale price</span><span class="price-item price-item--sale price-item--last">' + formatMoney(price, config) + '</span><span class="visually-hidden">Regular price</span><span><s class="price-item price-item--regular">' + formatMoney(compareAt, config) + '</s></span></div>'
        : '',
      '</div>',
      '</div>',
    ].join('');
  }

  function renderFacets(els, results, state) {
    if (!results) return;

    const showAvailability = !state.availabilityLocked;
    els.clear.hidden = state.refinements.size === 0 && state.priceRanges.size === 0 && state.availability.size === 0 && state.condition.size === 0;
    const lockedValues = getLockedValues(state);
    const visibleFacets = getVisibleFacets(state.config);
    const facetValues = Object.keys(results.facets || {}).length ? results.facets : deriveFacetsFromHits(results.hits || []);
    const selectedFormats = state.refinements.get(FORMAT_FACET_ATTRIBUTE) || new Set();
    if (!selectedFormats.size && facetValues && facetValues[FORMAT_FACET_ATTRIBUTE]) {
      state.formatFacetValues = Object.assign({}, facetValues[FORMAT_FACET_ATTRIBUTE]);
    }
    rememberStickyFacetValues(state, facetValues);

    const showCondition = state.config.collectionHandle === 'all';
    els.facets.innerHTML = (showAvailability ? renderAvailabilityFacet(state) : '') + (showCondition ? renderConditionFacet(state) : '') + renderPriceFacet(state) + visibleFacets.map(function (facet) {
      const values = facetValues && facetValues[facet.attribute] ? facetValues[facet.attribute] : {};
      const selected = state.refinements.get(facet.attribute) || new Set();
      const locked = lockedValues.get(facet.attribute) || new Set();
      const items = getFacetItems(facet.attribute, values, selected, locked, state);
      const defaultCollapsed = FACETS_COLLAPSED_BY_DEFAULT.has(facet.attribute);
      const opened = !defaultCollapsed || state.openedFacets.has(facet.attribute) || selected.size > 0 || locked.size > 0;
      const expanded = state.expandedFacets.has(facet.attribute);
      const collapsedLimit = getFacetCollapsedLimit(facet);
      const visibleItems = expanded ? items : items.slice(0, collapsedLimit);
      const canToggle = items.length > collapsedLimit;

      if (!items.length) return '';

      return [
        '<section class="algolia-discogs__facet' + (opened ? '' : ' is-collapsed') + '">',
        defaultCollapsed
          ? '<button type="button" class="algolia-discogs__facet-heading" data-facet-open="' + escapeAttribute(facet.attribute) + '" aria-expanded="' + (opened ? 'true' : 'false') + '"><span>' + escapeHtml(facet.label) + '</span><span>' + (opened ? '-' : '+') + '</span></button>'
          : '<h3 class="algolia-discogs__facet-title">' + escapeHtml(facet.label) + '</h3>',
        opened ? [
        '<ul class="algolia-discogs__facet-list">',
        visibleItems
          .map(function (item) {
            const isLocked = locked.has(item.value);
            const checked = selected.has(item.value) || isLocked ? ' checked' : '';
            const disabled = isLocked ? ' disabled' : '';
            return [
              '<li>',
              '<label class="algolia-discogs__facet-label">',
              '<input type="checkbox" data-facet-attribute="' + escapeAttribute(facet.attribute) + '" value="' + escapeAttribute(item.value) + '"' + checked + disabled + '>',
              '<span>' + escapeHtml(item.label || item.value) + '</span>',
              '<span class="algolia-discogs__facet-count">' + item.count + '</span>',
              '</label>',
              '</li>',
            ].join('');
          })
          .join(''),
        '</ul>',
        canToggle
          ? '<button type="button" class="algolia-discogs__show-more" data-facet-toggle="' + escapeAttribute(facet.attribute) + '">' + (expanded ? 'Show less' : 'Show more') + '</button>'
          : '',
        ].join('') : '',
        '</section>',
      ].join('');
    }).join('');
  }

  function getFacetCollapsedLimit(facet) {
    return FACET_COLLAPSED_LIMITS[facet.attribute] || FACET_COLLAPSED_LIMIT;
  }

  function renderAvailabilityFacet(state) {
    return [
      '<section class="algolia-discogs__facet">',
      '<h3 class="algolia-discogs__facet-title">Availability</h3>',
      '<ul class="algolia-discogs__facet-list">',
      AVAILABILITY_FILTERS.map(function (item) {
        const checked = state.availability.has(item.value) ? ' checked' : '';
        return [
          '<li>',
          '<label class="algolia-discogs__facet-label algolia-discogs__facet-label--availability">',
          '<input type="checkbox" data-availability value="' + escapeAttribute(item.value) + '"' + checked + '>',
          '<span>' + escapeHtml(item.label) + '</span>',
          '</label>',
          '</li>',
        ].join('');
      }).join(''),
      '</ul>',
      '</section>',
    ].join('');
  }

  function renderConditionFacet(state) {
    return [
      '<section class="algolia-discogs__facet">',
      '<h3 class="algolia-discogs__facet-title">Condition</h3>',
      '<ul class="algolia-discogs__facet-list">',
      [
        { label: 'New', value: 'new' },
        { label: 'Used', value: 'used' },
      ].map(function (item) {
        const checked = state.condition.has(item.value) ? ' checked' : '';
        return [
          '<li>',
          '<label class="algolia-discogs__facet-label algolia-discogs__facet-label--availability">',
          '<input type="checkbox" data-condition value="' + escapeAttribute(item.value) + '"' + checked + '>',
          '<span>' + escapeHtml(item.label) + '</span>',
          '</label>',
          '</li>',
        ].join('');
      }).join(''),
      '</ul>',
      '</section>',
    ].join('');
  }

  function getVisibleFacets(config) {
    return FACETS.filter(function (facet) {
      return facet.attribute !== 'meta.custom.genre' || GENRE_FACET_ROUTES.has(config.collectionHandle);
    });
  }

  function getInitialPage() {
    const page = Number(new URLSearchParams(window.location.search).get('page'));
    return Number.isFinite(page) && page > 1 ? Math.floor(page) - 1 : 0;
  }

  function updatePageUrl(page, replace) {
    if (!window.history || !window.history.pushState) return;

    const url = new URL(window.location.href);
    const publicPage = Number(page) + 1;
    if (publicPage > 1) {
      url.searchParams.set('page', String(publicPage));
    } else {
      url.searchParams.delete('page');
    }

    const nextUrl = url.pathname + url.search + url.hash;
    const currentUrl = window.location.pathname + window.location.search + window.location.hash;
    if (nextUrl === currentUrl) return;

    if (replace) {
      window.history.replaceState({ algoliaPage: page }, '', nextUrl);
    } else {
      window.history.pushState({ algoliaPage: page }, '', nextUrl);
    }
  }

  function renderPriceFacet(state) {
    return [
      '<section class="algolia-discogs__facet">',
      '<h3 class="algolia-discogs__facet-title">Price</h3>',
      '<ul class="algolia-discogs__facet-list">',
      PRICE_RANGES.map(function (range, index) {
        const checked = state.priceRanges.has(String(index)) ? ' checked' : '';
        return [
          '<li>',
          '<label class="algolia-discogs__facet-label algolia-discogs__facet-label--price">',
          '<input type="checkbox" data-price-range value="' + index + '"' + checked + '>',
          '<span>' + escapeHtml(range.label) + '</span>',
          '</label>',
          '</li>',
        ].join('');
      }).join(''),
      '</ul>',
      '</section>',
    ].join('');
  }

  function deriveFacetsFromHits(hits) {
    const facets = {};

    FACETS.forEach(function (facet) {
      facets[facet.attribute] = {};
    });

    hits.forEach(function (hit) {
      addHitFacetValues(facets, 'meta.custom.genre', getNested(hit, ['meta', 'custom', 'genre']));
      addHitFacetValues(facets, 'meta.custom.style', getNested(hit, ['meta', 'custom', 'style']));
      addHitFacetValues(facets, FORMAT_FACET_ATTRIBUTE, hit.format_groups || getNested(hit, ['meta', 'custom', 'format_group']));
      addHitFacetValues(facets, RAW_FORMAT_FACET_ATTRIBUTE, getNested(hit, ['meta', 'custom', 'format']));
      addHitFacetValues(facets, 'meta.custom.release_year', getNested(hit, ['meta', 'custom', 'release_year']));
    });

    return facets;
  }

  function addHitFacetValues(facets, attribute, value) {
    if (value === null || value === undefined || value === '') return;
    if (!facets[attribute]) return;

    const values = Array.isArray(value) ? value : [value];
    values.forEach(function (item) {
      const label = String(item);
      facets[attribute][label] = (facets[attribute][label] || 0) + 1;
    });
  }

  function rememberStickyFacetValues(state, facetValues) {
    STICKY_FACET_ATTRIBUTES.forEach(function (attribute) {
      const selected = state.refinements.get(attribute) || new Set();
      const values = facetValues && facetValues[attribute] ? facetValues[attribute] : null;
      if (!values) return;

      if (!selected.size || !state.stickyFacetValues[attribute]) {
        state.stickyFacetValues[attribute] = Object.assign({}, values);
      }
    });
  }

  function getFacetItems(attribute, values, selected, locked, state) {
    if (attribute === FORMAT_FACET_ATTRIBUTE) {
      return mergeFormatFacetValues(values, selected, locked, state);
    }

    return mergeFacetValues(getStickyFacetSourceValues(attribute, values, state), selected, locked, attribute);
  }

  function getStickyFacetSourceValues(attribute, values, state) {
    if (!STICKY_FACET_ATTRIBUTES.has(attribute)) return values;
    return Object.assign({}, state.stickyFacetValues[attribute] || {}, values || {});
  }

  function mergeFormatFacetValues(values, selected, locked, state) {
    const sourceValues = Object.assign({}, state.formatFacetValues || {}, values || {});
    const items = FORMAT_GROUPS.map(function (group) {
      const directCount = Number((values && values[group.value]) || sourceValues[group.value] || 0);
      const matches = directCount ? [] : getFormatGroupMatches(group, sourceValues);
      const count = directCount || matches.reduce(function (sum, value) {
        return sum + Number((values && values[value]) || sourceValues[value] || 0);
      }, 0);
      return {
        value: group.value,
        label: group.label,
        count: count,
        sortCount: count || (selected.has(group.value) ? 1 : 0),
      };
    }).filter(function (item) {
      return item.sortCount > 0 || selected.has(item.value);
    });

    selected.forEach(function (value) {
      if (!items.some(function (item) { return item.value === value; })) {
        items.unshift({ value: value, label: formatFacetLabel(value), count: 0, sortCount: 0 });
      }
    });

    locked.forEach(function (value) {
      if (!items.some(function (item) { return item.value === value; })) {
        items.unshift({ value: value, label: formatFacetLabel(value), count: 0, sortCount: 0 });
      }
    });

    return items.sort(function (a, b) {
      return b.sortCount - a.sortCount || a.label.localeCompare(b.label);
    });
  }

  function formatFacetLabel(value) {
    const group = FORMAT_GROUPS.find(function (item) {
      return item.value === value || item.label === value;
    });
    return group ? group.label : value;
  }

  function hasFormatToken(value, token) {
    const escapedToken = token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const pattern = new RegExp('(^|[^A-Z]|[0-9]+x)' + escapedToken + '($|[^A-Z])', 'i');
    return pattern.test(value);
  }

  function getFormatGroupMatches(group, values) {
    return Object.keys(values || {}).filter(function (value) {
      return group.test(value);
    });
  }

  function getLockedValues(state) {
    const locked = new Map();

    state.lockedFilters.flat().forEach(function (filter) {
      const splitAt = filter.indexOf(':');
      if (splitAt === -1) return;

      const attribute = filter.slice(0, splitAt);
      const value = filter.slice(splitAt + 1);
      const values = locked.get(attribute) || new Set();
      values.add(value);
      locked.set(attribute, values);
    });

    return locked;
  }

  function mergeFacetValues(values, selected, locked, attribute) {
    const items = Object.keys(values)
      .map(function (value) {
        return { value: value, count: values[value] };
      })
      .sort(function (a, b) {
        if (attribute === 'meta.custom.release_year') {
          return Number(b.value) - Number(a.value);
        }

        return b.count - a.count || a.value.localeCompare(b.value);
      });

    selected.forEach(function (value) {
      if (!items.some(function (item) { return item.value === value; })) {
        items.unshift({ value: value, count: 0 });
      }
    });

    locked.forEach(function (value) {
      if (!items.some(function (item) { return item.value === value; })) {
        items.unshift({ value: value, count: 0 });
      }
    });

    return items;
  }

  function buildPaginationFragment(results) {
    const template = document.createElement('template');
    if (results.nbPages <= 1) return template.content;

    const page = results.page;
    const last = results.nbPages - 1;
    const pages = [];
    const start = Math.max(0, page - 2);
    const end = Math.min(last, page + 2);

    if (page > 0) {
      pages.push('<a class="algolia-discogs__page" href="' + escapeAttribute(getPageUrl(page - 1)) + '" rel="prev" data-page="' + (page - 1) + '" aria-label="Previous page">Previous</a>');
    }
    for (let i = start; i <= end; i += 1) {
      pages.push('<a class="algolia-discogs__page" href="' + escapeAttribute(getPageUrl(i)) + '" data-page="' + i + '" aria-label="Page ' + (i + 1) + (i === page ? ', current page' : '') + '"' + (i === page ? ' aria-current="page"' : '') + '>' + (i + 1) + '</a>');
    }
    if (page < last) {
      pages.push('<a class="algolia-discogs__page" href="' + escapeAttribute(getPageUrl(page + 1)) + '" rel="next" data-page="' + (page + 1) + '" aria-label="Next page">Next</a>');
    }

    template.innerHTML = pages.join('');
    return template.content;
  }

  function commitPagination(els, fragment) {
    els.pagination.replaceChildren(fragment);
    els.pagination.dataset.serverRendered = 'false';
  }

  function getPageUrl(page) {
    const url = new URL(window.location.href);
    const publicPage = Number(page) + 1;
    if (publicPage > 1) {
      url.searchParams.set('page', String(publicPage));
    } else {
      url.searchParams.delete('page');
    }
    return url.pathname + url.search + url.hash;
  }

  function shouldHandlePaginationClick(event, link) {
    const target = (link.getAttribute('target') || '').toLowerCase();
    return !event.defaultPrevented
      && event.button === 0
      && !event.metaKey
      && !event.ctrlKey
      && !event.shiftKey
      && !event.altKey
      && (!target || target === '_self')
      && !link.hasAttribute('download');
  }

  function getImageUrl(hit) {
    const image = hit.product_image || hit.image;
    if (!image) return '';
    if (typeof image === 'string') return image;
    if (image.src) return image.src;
    if (image.url) return image.url;
    return '';
  }

  function syncWishlistButtons(root) {
    if (!window.FurtherWishlist || typeof window.FurtherWishlist.syncButtons !== 'function') return;
    window.FurtherWishlist.syncButtons(root || document);
  }

  function syncNotificationSignup(root) {
    if (!window.FurtherNotificationSignup || typeof window.FurtherNotificationSignup.bind !== 'function') return;
    window.FurtherNotificationSignup.bind(root || document);
  }

  function syncMiniPlayers(root) {
    if (!window.miniPlayer || typeof window.miniPlayer.initializeMiniPlayers !== 'function') return;
    window.miniPlayer.initializeMiniPlayers(root || document);
  }

  function getAudioTracks(hit) {
    const audio = getNested(hit, ['meta', 'custom', 'audio']) || hit.audio_tracks;
    if (!audio) return [];
    return (Array.isArray(audio) ? audio : [audio]).filter(function (track) {
      return typeof track === 'string' && track.length > 0;
    });
  }

  function initInsights(config) {
    const aa = getInsightsClient();
    if (!aa || !config.appId || !config.searchApiKey) return;

    try {
      aa('init', {
        appId: config.appId,
        apiKey: config.searchApiKey,
        useCookie: true,
      });
    } catch (error) {
      // Analytics must never block browsing.
    }
  }

  function trackProductClick(link, config, state) {
    const objectId = link.dataset.objectId;
    const indexName = link.dataset.indexName || getIndexName(config, state);
    const queryId = link.dataset.queryId;
    const position = Number(link.dataset.position);

    trackSearchAttributionFromElement(link);

    trackGa4(
      'algolia_product_clicked',
      Object.assign(baseEventParams(config, state), {
        product_id: link.dataset.productId,
        product_title: link.dataset.productTitle,
        object_id: objectId,
        index_name: indexName,
        position: position,
      })
    );

    trackAlgoliaObjectEvent('Product Clicked', indexName, objectId, queryId, position);
  }

  function trackRenderedSearchAttribution(root) {
    if (!root) return;
    root.querySelectorAll('[data-algolia-product-link]').forEach(trackSearchAttributionFromElement);
  }

  function trackSearchAttributionFromElement(element) {
    if (!element || !element.dataset) return;
    trackSearchAttribution(
      element.dataset.queryId,
      element.dataset.objectId,
      element.dataset.productId,
      element.dataset.indexName
    );
  }

  function trackSearchAttribution(queryId, variantId, productId, indexName) {
    if (!queryId || !variantId || !indexName) return;

    const clickData = {
      eventName: 'Added to cart',
      index: indexName,
      queryID: queryId,
      objectIDs: [variantId],
      productId: productId,
    };

    try {
      const localStorageKey = 'algolia_analytics_clicked_objects';
      const previousClickItems = JSON.parse(localStorage.getItem(localStorageKey) || '[]');
      const deduplicatedItems = Array.isArray(previousClickItems)
        ? previousClickItems.filter(function (item) {
            return !(
              item &&
              item.index === indexName &&
              Array.isArray(item.objectIDs) &&
              item.objectIDs.includes(variantId)
            );
          })
        : [];

      deduplicatedItems.push(clickData);
      localStorage.setItem(localStorageKey, JSON.stringify(deduplicatedItems));
    } catch (error) {
      // Attribution storage must never block browsing or adding to cart.
    }
  }

  function trackMiniPlayerPlay(player, config, state) {
    const link = player.closest('.card-wrapper') ? player.closest('.card-wrapper').querySelector('[data-algolia-product-link]') : null;
    const objectId = link ? link.dataset.objectId : '';
    const indexName = link ? link.dataset.indexName : getIndexName(config, state);
    const queryId = link ? link.dataset.queryId : '';
    const position = link ? Number(link.dataset.position) : undefined;

    trackGa4(
      'algolia_mini_player_played',
      Object.assign(baseEventParams(config, state), {
        product_id: player.dataset.productId,
        object_id: objectId,
        index_name: indexName,
        position: position,
      })
    );

    if (objectId) {
      trackAlgoliaObjectEvent('Mini Player Played', indexName, objectId, queryId, position);
    }
  }

  function trackFilterEvent(config, state, attribute, value, checked) {
    trackGa4(
      'algolia_filter_changed',
      Object.assign(baseEventParams(config, state), {
        filter_attribute: attribute,
        filter_value: value,
        checked: checked,
      })
    );

    if (!checked) return;

    const aa = getInsightsClient();
    if (!aa) return;

    try {
      aa('clickedFilters', {
        eventName: 'Filter Clicked',
        index: getIndexName(config, state),
        filters: [attribute + ':' + value],
      });
    } catch (error) {
      // Analytics must never block browsing.
    }
  }

  function trackAlgoliaObjectEvent(eventName, indexName, objectId, queryId, position) {
    const aa = getInsightsClient();
    if (!aa || !objectId || !indexName) return;

    try {
      if (queryId) {
        aa('clickedObjectIDsAfterSearch', {
          eventName: eventName,
          index: indexName,
          objectIDs: [objectId],
          positions: [position || 1],
          queryID: queryId,
        });
      } else {
        aa('clickedObjectIDs', {
          eventName: eventName,
          index: indexName,
          objectIDs: [objectId],
        });
      }
    } catch (error) {
      // Analytics must never block browsing.
    }
  }

  function trackGa4(eventName, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, params));
  }

  function baseEventParams(config, state) {
    return {
      collection_handle: config.collectionHandle || '',
      collection_title: config.collectionTitle || '',
      current_tag: config.currentTag || '',
      request_path: config.requestPath || window.location.pathname,
      sort: state.sort || '',
      page: (state.page || 0) + 1,
    };
  }

  function getInsightsClient() {
    return typeof window.aa === 'function' ? window.aa : null;
  }

  function getNested(object, path) {
    return path.reduce(function (value, key) {
      return value && value[key] !== undefined ? value[key] : undefined;
    }, object);
  }

  function parseMoneyValue(value) {
    if (value === null || value === undefined || value === '') return null;
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function formatMoney(value, config) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: config.shopCurrency || 'USD',
      }).format(value);
    } catch (error) {
      return '$' + value.toFixed(2);
    }
  }

  function showError(els, message) {
    if (els.error) {
      els.error.hidden = false;
      els.error.textContent = message;
    }
    if (els.count) els.count.textContent = 'Algolia collection unavailable';
  }

  function hideError(els) {
    if (!els.error) return;
    els.error.hidden = true;
    els.error.textContent = '';
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[char];
    });
  }

  function escapeAttribute(value) {
    return escapeHtml(value);
  }

  function productGid(value) {
    const cleaned = String(value || '').trim();
    if (!cleaned) return '';
    if (cleaned.indexOf('gid://shopify/Product/') === 0) return cleaned;
    const match = cleaned.match(/\/(\d+)$/);
    const numericId = match ? match[1] : cleaned;
    return /^\d+$/.test(numericId) ? 'gid://shopify/Product/' + numericId : '';
  }

  function cleanId(value) {
    return String(value || '').trim().replace(/[^a-zA-Z0-9_-]/g, '-') || 'item';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
